import { useTranslation } from 'react-i18next';

const poolImg = 'http://geel.fp.08wx.cn/images/52f879c53f46d7d0f28f6ac19aa1345d.jpg';

type LocaleKey = 'zh-CN' | 'en' | 'zh-TW';

const COPY = {
  'zh-CN': {
    badge: 'Mining Pool System',
    title1: '自建矿池系统',
    title2: '高稳定，低延迟，大算力',
    desc: '提供完整的矿池系统搭建方案，支持 BTC/LTC/DOGE/KAS 等主流算法，Stratum V2 协议，FPPS+ 结算，全球四大接入节点，助您运营独立品牌矿池，掌控算力生态。',
    perfTitle: '矿池性能参数',
    cardTitle: '矿池系统架构',
    cardMeta: 'Stratum V2 · FPPS+ · 全球四节点',
    earningsBadge: 'Earnings & Colocation',
    earningsTitle: '收益结算 + 托管服务',
    earningsDesc: '自动化日结，全托管运营，让您专注于资产增值',
    tags: ['BTC', 'LTC', 'DOGE', 'KAS', 'ETC', '自定义'],
    poolFeatures: [
      { icon: 'ri-stack-line', title: 'Stratum V2 协议', desc: '最新矿池通信协议，矿工可自选交易、抗中心化，延迟降低 50%' },
      { icon: 'ri-bar-chart-2-line', title: 'FPPS+ 结算模式', desc: '全额付款（含手续费），矿工不承担运气风险，日结稳定收入' },
      { icon: 'ri-global-line', title: '全球 Stratum 节点', desc: '北美/欧洲/亚太/中东四大节点，矿机就近接入，延迟 <5ms' },
      { icon: 'ri-dashboard-line', title: '实时矿机监控', desc: '算力趋势、拒绝率、温度、收益逐矿机可视化，异常告警推送' },
    ],
    perfRows: [
      { label: '矿池费率', val: '0.5%' },
      { label: '最低起付', val: '0.001 BTC' },
      { label: '接入延迟', val: '<5ms' },
      { label: '孤块率', val: '<0.1%' },
    ],
    earningsFeatures: [
      { icon: 'ri-money-dollar-circle-line', title: '每日自动结算', desc: '达到起付金额（0.001 BTC）自动结算到账，无需手动提款' },
      { icon: 'ri-pie-chart-line', title: '收益历史明细', desc: '逐日收益记录，难度调整影响分析，完整可下载收益报表' },
      { icon: 'ri-exchange-line', title: '多币种自动兑换', desc: '挖出 BTC 可选自动兑换为 USDT/ETH，锁定收益减少波动' },
      { icon: 'ri-building-line', title: '托管服务全覆盖', desc: '电费代扣、运维外包、矿机升级、保险服务全托管一站式' },
    ],
  },
  en: {
    badge: 'Mining Pool System',
    title1: 'Self-Hosted Mining Pool',
    title2: 'High Stability, Low Latency, Massive Hashrate',
    desc: 'End-to-end mining pool deployment supporting BTC/LTC/DOGE/KAS and other major algorithms, with Stratum V2, FPPS+ settlement, and four global access nodes for operating an independent branded pool.',
    perfTitle: 'Pool Performance Metrics',
    cardTitle: 'Pool Architecture',
    cardMeta: 'Stratum V2 · FPPS+ · Four Global Nodes',
    earningsBadge: 'Earnings & Colocation',
    earningsTitle: 'Reward Settlement + Managed Services',
    earningsDesc: 'Automated daily settlement and full-service operations so you can focus on asset growth.',
    tags: ['BTC', 'LTC', 'DOGE', 'KAS', 'ETC', 'Custom'],
    poolFeatures: [
      { icon: 'ri-stack-line', title: 'Stratum V2 Protocol', desc: 'Latest mining communication protocol with miner-selected transactions, decentralization resistance, and 50% lower latency.' },
      { icon: 'ri-bar-chart-2-line', title: 'FPPS+ Settlement Model', desc: 'Full payout including fees, minimizing luck variance and delivering stable daily revenue.' },
      { icon: 'ri-global-line', title: 'Global Stratum Nodes', desc: 'North America, Europe, APAC, and Middle East nodes with nearby access and <5ms latency.' },
      { icon: 'ri-dashboard-line', title: 'Real-Time Miner Monitoring', desc: 'Per-machine visibility for hashrate trends, reject rates, temperature, and revenue with alerts.' },
    ],
    perfRows: [
      { label: 'Pool Fee', val: '0.5%' },
      { label: 'Minimum Payout', val: '0.001 BTC' },
      { label: 'Access Latency', val: '<5ms' },
      { label: 'Orphan Rate', val: '<0.1%' },
    ],
    earningsFeatures: [
      { icon: 'ri-money-dollar-circle-line', title: 'Daily Auto Settlement', desc: 'Payouts are settled automatically once the threshold (0.001 BTC) is reached.' },
      { icon: 'ri-pie-chart-line', title: 'Historical Earnings Breakdown', desc: 'Daily earnings records, difficulty impact analysis, and downloadable full reports.' },
      { icon: 'ri-exchange-line', title: 'Multi-Asset Auto Conversion', desc: 'Optionally convert mined BTC to USDT/ETH automatically to reduce volatility.' },
      { icon: 'ri-building-line', title: 'Full Colocation Coverage', desc: 'One-stop managed services including power billing, maintenance, upgrades, and insurance.' },
    ],
  },
  'zh-TW': {
    badge: 'Mining Pool System',
    title1: '自建礦池系統',
    title2: '高穩定、低延遲、大算力',
    desc: '提供完整礦池系統搭建方案，支援 BTC/LTC/DOGE/KAS 等主流演算法，Stratum V2 協議、FPPS+ 結算與全球四大接入節點，助您營運獨立品牌礦池，掌控算力生態。',
    perfTitle: '礦池效能參數',
    cardTitle: '礦池系統架構',
    cardMeta: 'Stratum V2 · FPPS+ · 全球四節點',
    earningsBadge: 'Earnings & Colocation',
    earningsTitle: '收益結算 + 託管服務',
    earningsDesc: '自動化日結，全託管營運，讓您專注於資產增值',
    tags: ['BTC', 'LTC', 'DOGE', 'KAS', 'ETC', '自訂'],
    poolFeatures: [
      { icon: 'ri-stack-line', title: 'Stratum V2 協議', desc: '最新礦池通訊協議，礦工可自選交易、抗中心化，延遲降低 50%' },
      { icon: 'ri-bar-chart-2-line', title: 'FPPS+ 結算模式', desc: '全額付款（含手續費），礦工不承擔運氣風險，日結穩定收入' },
      { icon: 'ri-global-line', title: '全球 Stratum 節點', desc: '北美/歐洲/亞太/中東四大節點，礦機就近接入，延遲 <5ms' },
      { icon: 'ri-dashboard-line', title: '即時礦機監控', desc: '算力趨勢、拒絕率、溫度、收益逐礦機可視化，異常告警推送' },
    ],
    perfRows: [
      { label: '礦池費率', val: '0.5%' },
      { label: '最低起付', val: '0.001 BTC' },
      { label: '接入延遲', val: '<5ms' },
      { label: '孤塊率', val: '<0.1%' },
    ],
    earningsFeatures: [
      { icon: 'ri-money-dollar-circle-line', title: '每日自動結算', desc: '達到起付金額（0.001 BTC）自動結算到帳，無需手動提款' },
      { icon: 'ri-pie-chart-line', title: '收益歷史明細', desc: '逐日收益記錄，難度調整影響分析，完整可下載收益報表' },
      { icon: 'ri-exchange-line', title: '多幣種自動兌換', desc: '挖出 BTC 可選自動兌換為 USDT/ETH，鎖定收益降低波動' },
      { icon: 'ri-building-line', title: '託管服務全覆蓋', desc: '電費代扣、運維外包、礦機升級、保險服務全託管一站式' },
    ],
  },
};

export default function MiningPoolSection() {
  const { i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage || i18n.language || 'zh-CN').toLowerCase();
  const locale: LocaleKey = lang.startsWith('zh-tw') || lang.startsWith('zh-hk') ? 'zh-TW' : lang.startsWith('en') ? 'en' : 'zh-CN';
  const copy = COPY[locale];

  return (
    <section id="pool" className="bg-white py-24">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-14 xl:gap-20 mb-20">
          <div className="flex-1 min-w-0">
            <div className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full">
              <i className="ri-stack-line text-primary text-xs" />
              <span className="text-primary text-xs font-medium uppercase tracking-widest">{copy.badge}</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-4 leading-tight">
              {copy.title1}
              <br />
              <span className="text-primary">{copy.title2}</span>
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-8">{copy.desc}</p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              {copy.poolFeatures.map((f, i) => (
                <div key={i} className="bg-light-alt border border-primary/10 rounded-xl p-4 hover:border-primary/25 transition-all duration-200">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary/10 flex-shrink-0 mt-0.5">
                      <i className={`${f.icon} text-sm text-primary`} />
                    </div>
                    <div>
                      <h4 className="text-gray-800 text-sm font-medium mb-1">{f.title}</h4>
                      <p className="text-gray-500 text-xs leading-relaxed">{f.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-light-alt border border-primary/10 rounded-xl overflow-hidden">
              <div className="px-5 py-3 border-b border-primary/10 bg-primary/5">
                <span className="text-xs font-medium text-gray-400 uppercase tracking-wider">{copy.perfTitle}</span>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-4">
                {copy.perfRows.map((s, i) => (
                  <div key={i} className={`px-5 py-4 border-primary/10 ${i < 2 ? 'border-b sm:border-b-0' : ''} ${i % 4 !== 3 ? 'border-r' : ''}`}>
                    <div className="text-gray-400 text-xs mb-1">{s.label}</div>
                    <div className="text-primary font-semibold text-sm">{s.val}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:w-[420px] xl:w-[480px] flex-shrink-0">
            <div className="relative rounded-2xl overflow-hidden border border-primary/15 sticky top-24">
              <div className="w-full h-[320px]">
                <img src={poolImg} alt="Mining Pool" className="w-full h-full object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-white/60 via-transparent to-transparent" />
              </div>
              <div className="absolute top-4 left-4 bg-white/95 border border-primary/20 rounded-xl px-4 py-3 backdrop-blur-sm">
                <div className="flex items-center gap-2 mb-1">
                  <i className="ri-stack-line text-primary text-sm" />
                  <span className="text-gray-800 text-xs font-medium">{copy.cardTitle}</span>
                </div>
                <div className="text-gray-400 text-xs">{copy.cardMeta}</div>
              </div>
            </div>
          </div>
        </div>

        <div id="earnings">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 mb-4 px-3 py-1.5 bg-accent/10 border border-accent/20 rounded-full">
              <i className="ri-money-dollar-circle-line text-accent text-xs" />
              <span className="text-accent text-xs font-medium uppercase tracking-widest">{copy.earningsBadge}</span>
            </div>
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-gray-900 mb-3">{copy.earningsTitle}</h3>
            <p className="text-gray-500 text-sm max-w-xl mx-auto">{copy.earningsDesc}</p>
          </div>
          <div id="colocation" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {copy.earningsFeatures.map((f, i) => (
              <div key={i} className="bg-light-alt border border-primary/10 rounded-xl p-5 hover:border-accent/25 transition-all duration-200">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent/10 mb-4">
                  <i className={`${f.icon} text-accent text-lg`} />
                </div>
                <h4 className="text-gray-800 font-medium text-sm mb-2">{f.title}</h4>
                <p className="text-gray-500 text-xs leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
